import React, { Suspense, useContext, useEffect, useState, useCallback } from "react";
import { useLocation, Outlet } from "react-router-dom";
import classes from "./Layout.module.scss";
import TopNav from "../../../components/Navs/TopNav";
import AsideNav from "../../../components/Navigation";
import Bot from "../../../components/Bot";
import ProfileUpdateModal from "@components/ProfileUpdateModal";
import { API_Q_USER } from "@constants/api";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import useFetch from "@hooks/useFetch";
import { isAuthenticated } from "../../../helpers/sessionHelpers";
import ScrollToTop from "../../../components/UI/ScrollToTop";
import Notification from "../../../components/UI/Notify";
import SurveyBalloon from "../../../components/UI/SurveyBalloon/SurveyBalloon";
import { setAnalyticsGetProfile } from "@helpers/analyticsHelpers";
import Spinner from "../../../components/UI/Spinner";
import SystemContext from "../../../context/SystemContext";
import { updateMyUser } from "@store/actions/_LocalSession";
import {
  Box,
  CssBaseline,
  Drawer,
  Toolbar,
  AppBar,
  Container,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

const Layout = ({ check_cache_local }) => {
  //const noop = t('noopkey', "do the thing");

  const {
    setIsRegister,
    setIsPurchase,
    NeedUpdateSession,
    setNeedUpdateSession,
  } = useContext(SystemContext);
  const dispatch = useDispatch();

  const location = useLocation();
  const pathName = location.pathname;
  const { activeUser, session } = useSelector((state) => state.session);
  const [, , , fetchUser] = useFetch({
      url: API_Q_USER,
      autoInit: false,
    });

  const get2ndPath = (path, pathName) => {
    if (!path) path = "";
    const listPath = path.split("/");
    return listPath[1] === pathName ? true : false;
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentProfile, setCurrentProfile] = useState(null);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleProfileUpdate = useCallback(
    async (newProfile) => {
      return new Promise((resolve, reject) => {
        const userData = session?.my_user || {};
        // console.log("userData : ",userData)

        const updatedUserData = {
          profile: newProfile,
          
          // fiscal_document: userData.fiscal_document,
          // full_name: userData.full_name,
          // given_name: userData.given_name,
          // profession: userData.profession,
          // birth_date: userData.birth_date,
          // address_country: userData.address_country,
          // address_zipcode: userData.address_zipcode,
          // address_street: userData.address_street,
          // address_number: userData.address_number,
          // address_city: userData.address_city,
          // address_state: userData.address_state,
          // address_neighborhood: userData.address_neighborhood,
          // address_complement: userData.address_complement,
        };

        fetchUser({
          method: "PUT",
          url: API_Q_USER,
          data: updatedUserData,
          onSuccess: (response) => {
            console.log("Perfil atualizado com sucesso:", response);
            const updatedDate =
              response?.date_updated ||
              response?.my_user?.date_updated ||
              moment().format("YYYY-MM-DD HH:mm:ss");
            dispatch(
              updateMyUser({
                profile: newProfile,
                date_updated: updatedDate,
              }),
            );
            setAnalyticsGetProfile({ profile: newProfile });
            resolve(response);
          },
          onError: (error) => {
            console.error("Erro ao atualizar perfil:", error);
            reject(error);
          },
        });
      });
    },
    [fetchUser, session, dispatch],
  );

  useEffect(() => {
    setIsRegister(get2ndPath(pathName, "cadastro"));
    setIsPurchase(get2ndPath(pathName, "comprar"));
    if (NeedUpdateSession) {
      console.log("{NeedUpdateSession} ♾️");
      setNeedUpdateSession(false);
      global.updateSession(false);
    }
  }, [pathName]);

  useEffect(() => {
    if (session && !session?.my_user?.profile) {
      console.log("sessionlayout:", session);
      setIsModalOpen(true);
    }
  }, [session?.my_user?.profile]);

  // const check_is_main_redirect = () => {
  //   return ["/painel", "/login", "/cadastro"].indexOf(pathName) === -1;
  // };
  // useEffect(() => {
  //   if (
  //     session?.my_user?.typeUser &&
  //     urlRedirect != "" &&
  //     !check_is_main_redirect()
  //   ) {
  //     console.log("Redirect urlRedirect to pathName", urlRedirect, pathName);
  //     setUrlRedirect("");
  //     navigate(urlRedirect);
  //   }
  //   if (!session && check_is_main_redirect()) {
  //     setUrlRedirect(pathName);
  //     setTimeout(() => {
  //       if (pathName.includes(urlRedirect)) {
  //         setUrlRedirect("");
  //       }
  //     }, 1000);
  //   }
  // }, [session, urlRedirect, pathName]);

  useEffect(() => {
    check_cache_local?.();
  }, [check_cache_local, pathName]);

  const isUserAuthenticated = isAuthenticated();

  const _loading = (
    <div className={classes.LoadingArea}>
      <Spinner />
    </div>
  );

  const [botAfinando, setBotAfinando] = useState(null);

  useEffect(() => {
    if (
      (isUserAuthenticated && pathName === "/painel") ||
      (isUserAuthenticated && pathName === "/comprar")
    ) {
      setBotAfinando(<Bot />);
    } else {
      setBotAfinando(null);
    }
  }, [isUserAuthenticated, pathName]);

  const drawerWidth = 220;
  const theme = useTheme();
  const toolbarStyle = {
    minHeight: "80px",
  };
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ display: "flex", padding: 0 }}
    >
      <Suspense fallback={_loading}>
        <CssBaseline />

        <Drawer
          variant={"permanent"}
          anchor={isMobile ? "bottom" : "left"}
          sx={{
            width: isMobile ? "0px" : drawerWidth,
            flexShrink: 0,

            [`& .MuiDrawer-paper`]: {
              width: isMobile ? "0px" : drawerWidth,
              boxSizing: "border-box",
              marginTop: 0,
              height: "100vh",
            },
          }}
        >
          <Box sx={{ overflow: "auto", padding: 0 }}>
            <AsideNav isUserAuthenticated={isUserAuthenticated} />
          </Box>
        </Drawer>

        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer - 1,
            left: { xs: 0, lg: `${drawerWidth}px` },
            width: { xs: "100%", lg: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar>
            <TopNav />
          </Toolbar>
        </AppBar>

        <Grid container sx={{ flexGrow: 1, display: "flex" }}>
          <Grid item size={12} sx={{ minHeight: "100vh" }}>
            <Toolbar style={toolbarStyle} />

            <Outlet />
            <ScrollToTop />
            {/* {session?.my_user?.typeUser?.includes("patient") && botAfinando} */}
          </Grid>

          <Grid item size={12}>
            <Notification />
            <SurveyBalloon />
          </Grid>
        </Grid>
        <ProfileUpdateModal
          open={isModalOpen}
          onClose={handleCloseModal}
          currentProfile={currentProfile}
          onProfileUpdate={handleProfileUpdate}
        />
      </Suspense>
    </Container>
  );
};

export default Layout;
